import React, {useRef, useEffect} from 'react'
import { gsap } from "gsap";

const OpacityAnimation = (props) => {

    const mainRef = useRef();

    useEffect(() => {
        gsap.fromTo(mainRef.current, { opacity: 0}, {opacity: 1, duration: 2, delay:0.5, ease: 'linear'});
    });

  return (
    <React.Fragment >
      <main ref={mainRef}>
        {props.children}
      </main> 
    </React.Fragment>
  )
}

export default OpacityAnimation
